import { NavLink, useLocation } from 'react-router';
import { LayoutGrid, List, LogOut, Settings, Users } from 'lucide-react';
import { ROUTES } from '@/constants';
import { useLogout } from '@/services/queries';
import { useAppSelector } from '@/store/hooks';
import { AppShell, navItemClass, type NavItem } from '@/shared/ui/app-shell';
import { Logo } from '@/shared/ui/logo';

const NAV: NavItem[] = [
  { to: ROUTES.dashboard, label: 'Dashboard', icon: <LayoutGrid size={16} strokeWidth={1.8} /> },
  { to: ROUTES.customers, label: 'Organizations', icon: <Users size={16} strokeWidth={1.8} /> },
  { to: ROUTES.audit, label: 'Action Log', icon: <List size={16} strokeWidth={1.8} /> },
  { to: ROUTES.security, label: 'Settings', icon: <Settings size={16} strokeWidth={1.8} /> },
];

const TITLES: Record<string, string> = {
  [ROUTES.dashboard]: 'Global Dashboard',
  [ROUTES.customers]: 'Organizations',
  [ROUTES.audit]: 'Admin Action Log',
  [ROUTES.security]: 'Admin Settings',
};

export function Sidebar({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const user = useAppSelector((state) => state.auth.user);
  const logout = useLogout();

  return (
    <AppShell
      title={TITLES[pathname] ?? ''}
      portalName="Admin"
      storageKey="nudent.sidebar.admin"
      logo={<Logo />}
      nav={NAV}
      user={user ? { name: user.name, role: user.role } : undefined}
      renderLink={(item, content, collapsed) => (
        <NavLink
          to={item.to}
          title={collapsed ? item.label : undefined}
          className={({ isActive }) => navItemClass(isActive, collapsed)}
        >
          {content}
        </NavLink>
      )}
      footer={
        <>
          <button
            type="button"
            disabled={logout.isPending}
            onClick={() => {
              logout.mutate();
            }}
            className={navItemClass(false, false)}
          >
            <span className="flex size-4 shrink-0 items-center justify-center">
              <LogOut size={16} strokeWidth={1.8} />
            </span>
            <span className="truncate">Sign out</span>
          </button>
        </>
      }
    >
      {children}
    </AppShell>
  );
}
